import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/** Stable ids for Watch page accordion sections (single open at a time). */
export type WatchAccordionSectionId =
    | 'notices'
    | 'subscription'
    | 'courses'
    | 'series'
    | 'evaluation'
    | 'studyResources';

type WatchAccordionState = {
    openSectionId: WatchAccordionSectionId | null;
};

const initialState: WatchAccordionState = {
    openSectionId: null,
};

export const watchAccordionSlice = createSlice({
    name: 'watchAccordion',
    initialState,
    reducers: {
        setWatchAccordionOpenSection: (
            state,
            action: PayloadAction<WatchAccordionSectionId | null>
        ) => {
            state.openSectionId = action.payload;
        },
    },
});

export const { setWatchAccordionOpenSection } = watchAccordionSlice.actions;

export default watchAccordionSlice.reducer;
